<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="1000">
      <template v-slot:activator="{ on }">
        <v-btn color="red lighten-2" dark v-on="on">{{$t('address_create.new_contact')}}</v-btn>
      </template>
      <v-card>
        <v-card-title class="headline lighten-2" primary-title>{{$t('address_create.new_contact')}}</v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="contact.name"
                  :label="$t('contact_create.name')"
                  @keyup.enter="enterAction"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="contact.email"
                  :label="$t('contact_create.email')"
                  @keyup.enter="enterAction"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="contact.mobile"
                  :label="$t('contact_create.mobile')"
                  @keyup.enter="enterAction"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-switch v-model="contact.notify" :label="$t('contact_create.notify')"></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="!editing" color="primary" flat @click="save">{{$t('contact_create.save')}}</v-btn>
          <v-btn v-if="editing" color="primary" flat @click="edit">{{$t('contact_create.edit')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Contact from "@/models/Contact.js";
export default {
  name: "contact-create",
  props: ["customer"],
  data() {
    return {
      dialog: false,
      editing: false,
      contact: {
        name: "",
        email: "",
        mobile: "",
        notify: false,
        customer_id: this.customer.id
      },
      contactId: -1,
    };
  },
  watch: {
    dialog() {
      this.contact = {
        name: "",
        email: "",
        mobile: "",
        notify: false,
        customer_id: this.customer.id
      };
      (this.editing = false), (this.contactId = -1);
    }
  },
  methods: {
    enterAction() {
      if (this.editing) {
        this.edit();
      } else {
        this.save();
      }
    },
    async save() {
      const contact = await Contact.create(this.contact);
      this.contactId = contact.id;
      this.editing = true;
      this.dialog = false;
      this.$emit("contactCreated");
    },
    async edit() {
      await Contact.update(this.contactId, this.contact);
      this.dialog = false;
      this.$emit("contactCreated");
    },
    /**
     * load contacts from outside of component
     */
    loadContact(contact) {
      setTimeout(() => {
        this.editing = true;
        this.contactId = contact.id;
        this.contact = {
          name: contact.name,
          email: contact.email,
          mobile: contact.mobile,
          notify: contact.notify,
          customer_id: contact.customer_id
        };
      }, 50);
      this.dialog = true;
    }
  }
};
</script>
